import api from './client';
import ApiError from './error';

const ContentService = {
  async searchContent() {
    try {
      const client = await api.getClient();
      return client.searchContent();
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async viewContent({ id }) {
    try {
      const client = await api.getClient();
      return client.viewContent(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async createContent({ data }) {
    try {
      const client = await api.getClient();
      return client.createContent(null, data);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async updateContent({ id, data }) {
    try {
      const client = await api.getClient();

      // Axios takes it as an actual error and rejects the promise
      client.interceptors.response.use((response) => response, (error) => {
        if (error.response.status === 303) {
          return Promise.resolve(error.response);
        }

        return Promise.reject(error);
      });

      return client.updateContent(id, data);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async deleteContent({ id }) {
    try {
      const client = await api.getClient();
      return client.deleteContent(id);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default ContentService;
